import { render, staticRenderFns } from "./SetsReceive.vue?vue&type=template&id=688c994d&scoped=true&"
import script from "./SetsReceive.vue?vue&type=script&lang=js&"
export * from "./SetsReceive.vue?vue&type=script&lang=js&"
import style0 from "./SetsReceive.vue?vue&type=style&index=0&id=688c994d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688c994d",
  null
  
)

export default component.exports